"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseNearApiJsTransactions = void 0;
const bn_js_1 = __importDefault(require("bn.js"));
const crypto_1 = require("@near-js/crypto");
const transactions_1 = require("@near-js/transactions");
const core_1 = require("@multi-transaction/core");
function parseNearApiJsTransactions(mTransaction) {
    return mTransaction.toTransactions().map((transaction) => parseNearApiJsTransaction(transaction));
}
exports.parseNearApiJsTransactions = parseNearApiJsTransactions;
function parseNearApiJsTransaction(transaction) {
    const { receiverId, actions } = transaction;
    return {
        receiverId,
        actions: actions.map((action) => parseNearApiJsAction(action)),
    };
}
function parseNearApiJsAction(action) {
    if (action.type === 'CreateAccount') {
        return transactions_1.actionCreators.createAccount();
    }
    if (action.type === 'DeleteAccount') {
        const { beneficiaryId } = action.params;
        return transactions_1.actionCreators.deleteAccount(beneficiaryId);
    }
    if (action.type === 'AddKey') {
        const { publicKey, accessKey } = action.params;
        return transactions_1.actionCreators.addKey(crypto_1.PublicKey.fromString(publicKey), parseNearApiJsAccessKey(accessKey));
    }
    if (action.type === 'DeleteKey') {
        const { publicKey } = action.params;
        return transactions_1.actionCreators.deleteKey(crypto_1.PublicKey.fromString(publicKey));
    }
    if (action.type === 'DeployContract') {
        const { code } = action.params;
        return transactions_1.actionCreators.deployContract(code);
    }
    if (action.type === 'Stake') {
        const { amount, publicKey } = action.params;
        return transactions_1.actionCreators.stake(new bn_js_1.default(amount), crypto_1.PublicKey.fromString(publicKey));
    }
    if (action.type === 'FunctionCall') {
        const { methodName, args, gas, attachedDeposit } = action.params;
        return transactions_1.actionCreators.functionCall(methodName, args, new bn_js_1.default(gas), new bn_js_1.default(attachedDeposit));
    }
    if (action.type === 'Transfer') {
        const { amount } = action.params;
        return transactions_1.actionCreators.transfer(new bn_js_1.default(amount));
    }
    throw new core_1.UnreachableError();
}
function parseNearApiJsAccessKey(accessKey) {
    if (accessKey.permission === 'FullAccess') {
        return transactions_1.actionCreators.fullAccessKey();
    }
    else {
        const { receiverId, methodNames, allowance } = accessKey.permission;
        return transactions_1.actionCreators.functionCallAccessKey(receiverId, methodNames, allowance ? new bn_js_1.default(allowance) : undefined);
    }
}
//# sourceMappingURL=utils.js.map